<template>
  <div>
    <v-tabs>
      <v-tab v-if="$ability.can('Visualizar','Leads Vendedor')" href="#tab-vendedor">Vendedor</v-tab>
      <v-tab v-if="$ability.can('Visualizar','Leads Supervisor')" href="#tab-supervisor">Supervisor</v-tab>
      <v-tab
        v-if="$ability.can('Visualizar','Leads Administrador')"
        href="#tab-administrador"
      >Administrador</v-tab>
      <v-tab
        v-if="$ability.can('Visualizar','Leads Administrativo')"
        href="#tab-administrativo"
      >Administrativo</v-tab>

      <v-tab-item v-if="$ability.can('Visualizar','Leads Vendedor')" value="tab-vendedor">
        <Vendedor />
      </v-tab-item>

      <v-tab-item v-if="$ability.can('Visualizar','Leads Supervisor')" value="tab-supervisor">
        <Supervisor />
      </v-tab-item>

      <v-tab-item v-if="$ability.can('Visualizar','Leads Administrador')" value="tab-administrador">
        <Administrador />
      </v-tab-item>

      <v-tab-item
        v-if="$ability.can('Visualizar','Leads Administrativo')"
        value="tab-administrativo"
      >
        <Administrador />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Gerenciar",

  components: {
    Vendedor: () => import("./vendedor/Vendedor"),
    Supervisor: () => import("./supervisor/Supervisor"),
    Administrador: () => import("./administrador/Administrador"),
    Administrativo: () => import("./administrativo/Administrativo")
  }
};
</script>
